import validator from 'validator';

const isNonEmptyString = (value: string | unknown): value is string =>
  !!value && typeof value === 'string' && value.trim().length > 0;

const isNonEmptyArray = (list: any[]): boolean => !!list && Array.isArray(list) && list.length > 0;

const hasSomeValue = (list: any[]): boolean =>
  list.some((el) => {
    return (typeof el === 'string' && isNonEmptyString(el)) || !!el;
  });

const isEqualJson = (a: any, b: any): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};

const isAttributeType = (type: string, value: any): boolean => {
  switch (type) {
    case 'BOOLEAN':
      return (
        typeof value === 'boolean' || typeof value === 'number' || validator.isBoolean(String(value), { loose: true })
      );
    case 'NUMBER':
      return typeof value === 'number' || validator.isNumeric(String(value));
    case 'DATE':
      return validator.isDate(String(value), {
        strictMode: false, // Must be false. True is incompatible with delimiters array.
        format: 'YYYY-MM-DD',
        delimiters: ['-', '/'], // format can be 'YYYY-MM-DD' or 'YYYY/MM/DD'
      });
    case 'EMAIL':
      return validator.isEmail(String(value));
    case 'STRING':
    default:
      return typeof value === 'string';
  }
};

const hasAttributeValue = (value: any): boolean => {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim() !== '';
  }

  return true;
};

const hasDuplicates = (list: any[]): boolean => {
  if (!Array.isArray(list)) return false;

  return list.length > new Set(list).size;
};

const toBoolean = (value: string = '', isStrict: boolean = false): boolean => {
  const v = String(value).toLowerCase();

  switch (v) {
    case 'no':
      return false;
    case 'yes':
      return true;
    default:
      return validator.toBoolean(value, isStrict);
  }
};

const isNotEmptyObject = (obj: any): boolean => {
  return !!obj && typeof obj === 'object' && Object.keys(obj).length > 0;
};

export const validate = {
  isDate: validator.isDate,
  isEmail: validator.isEmail,
  isBoolean: validator.isBoolean,
  isNumeric: validator.isNumeric,

  hasAttributeValue,
  hasDuplicates,
  hasSomeValue,
  isAttributeType,
  isEqualJson,
  isNonEmptyArray,
  isNonEmptyString,
  toBoolean,
  isNotEmptyObject,
};
